import React from 'react';
import { Link, useParams } from 'react-router-dom';
import '../styles/CollectionsPage.css';

// ➕ ADD these photo arrays here
const vinlandsLensPhotos = [
  require('../assets/vinlands1.jpg'),
  require('../assets/vinlands2.jpg'),
  require('../assets/vinlands3.jpg'),
  require('../assets/vinlands4.jpg'),
  require('../assets/vinlands5.jpg'),
  require('../assets/vinlands6.jpg'),
  require('../assets/vinlands7.jpg'),
  require('../assets/vinlands8.jpg'),
  require('../assets/vinlands9.jpg'),
  require('../assets/vinlands10.jpg')
];

const harshitsLensPhotos = [
  require('../assets/harshits1.jpg'),
  require('../assets/harshits2.jpg'),
  require('../assets/harshits3.jpg'),
  require('../assets/harshits4.jpg'),
  require('../assets/harshits5.jpg'),
  require('../assets/harshits6.jpg'),
  require('../assets/harshits7.jpg'),
  require('../assets/harshits8.jpg'),
  require('../assets/harshits9.jpg'),
  require('../assets/harshits10.jpg')
];

const danushsLensPhotos = [
  require('../assets/danushs1.jpg'),
  require('../assets/danushs2.jpg'),
  require('../assets/danushs3.jpg'),
  require('../assets/danushs4.jpg'),
];

const sachinsLensPhotos = [
  require('../assets/sachins1.jpg'),
  require('../assets/sachins2.jpg'),
  require('../assets/sachins3.jpg'),
  require('../assets/sachins4.jpg'),
  require('../assets/sachins5.jpg'),
  require('../assets/sachins6.jpg'),
  require('../assets/sachins7.jpg'),
  require('../assets/sachins8.jpg'),
  require('../assets/sachins9.jpg'),
  require('../assets/sachins10.jpg')
];

const melodyPhotos = [
  require('../assets/melody1.jpg'),
  require('../assets/melody2.jpg'),
  require('../assets/melody3.jpg'),
  require('../assets/melody4.jpg'),
  require('../assets/melody5.jpg'),
  require('../assets/melody6.jpg'),
  require('../assets/melody7.jpg'),
  require('../assets/melody8.jpg'),
  require('../assets/melody9.jpg'),
  require('../assets/melody10.jpg')
];


function CollectionsPage() {
  const { collectionName } = useParams();

  const collections = [
    {
      id: 'vinlands-lens',
      title: "Vinland's Lens",
      subtitle: 'Personal Photography',
      coverImage: vinlandsLensPhotos[0],
      photoCount: '10 photos'
    },
    {
      id: 'harshits-lens',
      title: "Harshit's Lens",
      subtitle: 'Guest Collection',
      coverImage: harshitsLensPhotos[0],
      photoCount: '10 photos'
    },
    {
      id: 'danushs-lens',
      title: "Dhanush's Lens",
      subtitle: 'Guest Collection',
      coverImage: danushsLensPhotos[0],
      photoCount: '4 photos'
    },
    {
      id: 'sachins-lens',
      title: "Sachin's Lens",
      subtitle: 'Guest Collection',
      coverImage: sachinsLensPhotos[0],
      photoCount: '10 photos'
    },
    {
      id: 'melody',
      title: 'Melody',
      subtitle: 'Portrait Collection',
      coverImage: melodyPhotos[0],
      photoCount: '10 photos'
    }
  ];

  // Select photos for the current collection
  let photosToShow = [];

  if (collectionName === 'vinlands-lens') photosToShow = vinlandsLensPhotos;
  else if (collectionName === 'harshits-lens') photosToShow = harshitsLensPhotos;
  else if (collectionName === 'danushs-lens') photosToShow = danushsLensPhotos;
  else if (collectionName === 'sachins-lens') photosToShow = sachinsLensPhotos;
  else if (collectionName === 'melody') photosToShow = melodyPhotos;

  // If viewing a specific collection detail page
  if (collectionName) {
    const collection = collections.find(c => c.id === collectionName);
    if (collection) {
      return (
        <div className="collection-detail-page">
          <div className="collection-header">
            <Link to="/collections" className="back-link">← Back to Collections</Link>
            <h1>{collection.title}</h1>
            <p>{collection.subtitle}</p>
          </div>

          <div className="collection-gallery">
            <div className="gallery-grid">
              {photosToShow.map((src, idx) => (
                <div key={idx} className="gallery-item">
                  <img src={src} alt={`${collection.title} Photo ${idx + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
  }

  // Main collections overview page
  return (
    <div className="collections-page">
      <div className="collections-header">
        <h1>All Lens Collections</h1>
        <p>Explore photography through different perspectives</p>
      </div>

      <div className="collections-grid">
        {collections.map(collection => (
          <Link
            key={collection.id}
            to={`/collections/${collection.id}`}
            className="collection-item"
          >
            <div className="collection-image">
              <img src={collection.coverImage} alt={collection.title} />
              <div className="collection-overlay">
                <div className="collection-info">
                  <h3>{collection.title}</h3>
                  <p>{collection.subtitle}</p>
                  <span className="photo-count">{collection.photoCount}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default CollectionsPage;
